// extracted by mini-css-extract-plugin
export default {"serviceDescription":"ServiceDescription_serviceDescription__Mmgbq","serviceTitle":"ServiceDescription_serviceTitle__9Fiux","serviceText":"ServiceDescription_serviceText__MKbhe"};